// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"37bf5eea","453":"647851d0","828":"5de19449"}[chunkId] + ".chunk.js";
};